<template>

    <div>
        <Row :gutter="16">
            <Col span="24">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row>
                        <Col>
                            <Form :model="formItem" :label-width="80" label-position="right">
                                <FormItem :label="t.dept.name" prop="name">
                                    <Input v-model="formItem.name" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.dept.leader" prop="leader">
                                    <Input v-model="formItem.leader" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.dept.status" prop="status">
                                    <Input v-model="formItem.status" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.dept.mobile" prop="mobile">
                                    <Input v-model="formItem.mobile" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.dept.email" prop="email">
                                    <Input v-model="formItem.email" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.dept.sortOrder" prop="sortOrder">
                                    <Input v-model="formItem.sortOrder" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.dept.createBy" prop="createBy">
                                    <Input v-model="formItem.createBy" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.dept.createTime" prop="createTime">
                                    <Input v-model="formItem.createTime" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.dept.updateBy" prop="updateBy">
                                    <Input v-model="formItem.updateBy" readonly></Input>
                                </FormItem>
                                <FormItem :label="t.dept.updateTime" prop="updateTime">
                                    <Input v-model="formItem.updateTime" readonly></Input>
                                </FormItem>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>
<script>
import { getDeptInfo } from '@/api/dept';

export default {
    name: 'organization_dept_detail',
    data() {
        const t = this.$_t();
        return {
            self: this,
            t: t,
            formItem: {
                name: '',
                leader: '',
                status: '',
                mobile: '',
                email: '',
                sortOrder: 0,
                createBy: '',
                createTime: '',
                updateBy: '',
                updateTime: '',
            },
        };
    },
    methods: {
        async init() {
            const deptInfo = await getDeptInfo(this.$route.params.id);
            this.formItem = deptInfo.dept;

            //状态判断
            if (deptInfo.dept.status === '0') {
                this.formItem.status = this.t.dept.close;
            } else if (deptInfo.dept.status === '1') {
                this.formItem.status = this.t.dept.open;
            }
        },
    },
    async mounted() {
        await this.init();
    },
};
</script>
<style lang="less" scoped>
</style>
